module.exports = __webpack_public_path__ + "assets/svg/Icons/32/dashboard-gray-92030f.svg";